import { CHAT_IMAGE_MIME_TYPES } from 'constants/files'

const getChatImageMimeType = ({ name, type }: File): string | undefined => {
  if (type) return type.startsWith('image/') ? type : undefined
  const extension = name.includes('.') ? name.split('.').pop()?.toLowerCase() : undefined
  return extension ? CHAT_IMAGE_MIME_TYPES[extension] : undefined
}

const isChatImage = (file: File) => getChatImageMimeType(file) !== undefined

export { getChatImageMimeType, isChatImage }
